import { useEffect, useState } from "react";

import { useStorage } from "@/utils/functions";

import { useAdonisChat } from "../AdonisChatProvider/AdonisChatProvider";

export const ADONIS_DYNAMIC_CTA_BANNER_PERSISTENCE_KEY =
  "is-adonis-cta-dynamic-banner-viewed";

export const useAdonisDynamicCTABanner = (shouldShowAdonisCTA: boolean) => {
  const [isViewed, setIsViewed] = useStorage(
    ADONIS_DYNAMIC_CTA_BANNER_PERSISTENCE_KEY,
    false
  );
  const { showCTABanner, setShowCTABanner } = useAdonisChat();
  const [showAdonisDynamicCTABanner, setShowAdonisDynamicCTABanner] =
    useState(false); // This have to be false because we want it to show after 4 seconds

  // Reset CTA banner visibility when component mounts (home page is navigated to)
  useEffect(() => {
    if (isViewed) {
      return;
    }

    setShowCTABanner(true);
  }, [isViewed, setShowCTABanner]);

  // Show Adonis Dynamic CTA Banner after 4 seconds
  useEffect(() => {
    let timerId: NodeJS.Timeout;
    if (!isViewed && shouldShowAdonisCTA && showCTABanner) {
      timerId = setTimeout(() => {
        setShowAdonisDynamicCTABanner(true);
      }, 4000);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [isViewed, shouldShowAdonisCTA, showCTABanner]);

  const hideCTABanner = () => {
    setIsViewed(true);
    setShowCTABanner(false);
    setShowAdonisDynamicCTABanner(false);
  };

  return {
    showAdonisDynamicCTABanner,
    hideCTABanner,
  };
};
